<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Change Email Address</h1>
    </header>
    <section id="modal-body">
        <p i18n class="info-text">Do you want to change your email address to: </p>
        <h2 i18n  class="email">{{email}}</h2>
        <div id="warning-container">
            <mat-icon>warning</mat-icon>
            <div id="warning-text-container">
                <p i18n >The email address you change to will become your new username to log in with.<br>
                    You will be logged out after confirming email change!</p>
            </div>
        </div>
      
    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" mat-dialog-close="success">
            OK
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" mat-dialog-close="fail">
            Cancel
        </button>
    </footer>
</div>